import { StorageItem } from './constants';
import { getGlobalState, setGlobalState } from './globalState.service';
import { addToMasterCategory } from "../api/GraphProvider";

const checkTheme = (): boolean => {
  try {
    try {
      const settings = JSON.parse(localStorage.getItem(StorageItem.Settings));
      if (settings) return settings.darkTheme;
    } catch { }

    const background = Office.context.officeTheme.bodyBackgroundColor;
    return background.toLocaleLowerCase() !== '#ffffff';
  } catch {
    return false;
  }
}

export const checkPendingCategory = (): boolean => {
  try {
    const settings = JSON.parse(localStorage.getItem(StorageItem.Settings));
    if (settings) return settings.pendingCategory;
  } catch { return false; }
  return false;
}

export const checkShowAllTasks = (): boolean => {
  try {
    const settings = JSON.parse(localStorage.getItem(StorageItem.Settings));
    if (settings) return settings.showAllTasks;
  } catch { return false; }
  return false;
}

Office.onReady(() => {
  const darkTheme = checkTheme();
  const pendingCategory = checkPendingCategory();
  const showAllTasks = checkShowAllTasks();
  setGlobalState('settings', { darkTheme, pendingCategory, showAllTasks });})

export const setDarkTheme = (value: boolean) => {
  const pendingCategory = checkPendingCategory();
  const showAllTasks = checkShowAllTasks();
  localStorage.setItem(StorageItem.Settings, JSON.stringify({ darkTheme: value, pendingCategory: pendingCategory, showAllTasks: showAllTasks }));
  setGlobalState('settings', { darkTheme: value, pendingCategory: pendingCategory, showAllTasks: showAllTasks })
}

export const setPendingCategory = (value: boolean) => {
  addToMasterCategory("Pending");
  const darkTheme = checkTheme();
  const showAllTasks = checkShowAllTasks();
  localStorage.setItem(StorageItem.Settings, JSON.stringify({ pendingCategory: value, darkTheme: darkTheme, showAllTasks: showAllTasks }));
  setGlobalState('settings', { pendingCategory: value, darkTheme: darkTheme, showAllTasks: showAllTasks})
}

export const setShowAllTasks = (value: boolean) => {
  const pendingCategory = checkPendingCategory();
  const darkTheme = checkTheme();
  localStorage.setItem(StorageItem.Settings, JSON.stringify({ darkTheme: darkTheme, pendingCategory: pendingCategory, showAllTasks: value }));
  setGlobalState('settings', { darkTheme: darkTheme, pendingCategory: pendingCategory, showAllTasks: value })
}
